import { defaultOctopusObj } from "@/libs/common";
import { defineStore } from "pinia";

const defaultForm = () => {
  return {
    id: null,
    email: null,
    mobile: null,
    dob: null,
    hasARA: [],
    octopus: defaultOctopusObj(),
  };
};

const defaultResendObj = () => {
  return {
    counter: 60,
    disabled: false,
    text: "",
  }
}

export const useEmailStore = defineStore("email", {
  state: () => {
    return {
      jwt: null,
      agree: false,
      form: defaultForm(),
      resend: defaultResendObj()
    };
  },
  actions: {
    updateEmailUpdateJWT(val){
      this.jwt = val;
    },
    updateEmailUpdAgree(val) {
      this.agree = val;
    },
    setForm(obj) {
      this.form = obj;
    },
    setResend(obj) {
      this.resend = obj;
    },
    resetResend() {
      this.resend = defaultResendObj();
    },
    resetForm() {
      this.form = defaultForm();
    },
    resetEmailUpdateState(removeJWT = true) {
      if(removeJWT) {
        this.jwt = null;
      }
      this.agree = false;
      this.form = defaultForm();
      this.resend = defaultResendObj();
    },
  },
  persist: true
});
